import { Icon } from "@material-ui/core"
import React, { Fragment, useState } from "react"
import { AirportSeasonConfigurations } from "../../api/AirportSeasonConfiguration"
import { Flight } from "../../api/Flight"

import { ActionCode, FlightMode, PageGroup } from "../../common/transaction"
import TransactionFlightTurnaroundFields from "./TransactionFlightTurnaroundFields"
import _ from "lodash"
import { CodeType } from "../AirportSelector"
import { FieldName } from "../../common/text"
import { CustomShowLabelConfig } from "./TransactionFlightHeaders"

interface Props {
  flights: Flight[]
  airports: string[]
  transId: number
  pageGroup: PageGroup
  gcrMode: string
  codeType: CodeType
  airportSeasons: AirportSeasonConfigurations
  flightChanges: Array<string[]>
  inFocus?: boolean
  touched?: boolean
  isEditSeries?: boolean
  onChange?: (
    flights: Flight[],
    error: boolean,
    field: string,
    val: any
  ) => void
  onFillDown?: (flightIdx: number, field: FieldName) => void
  customShowLabelConfig: CustomShowLabelConfig
}

const TransactionFlightTurnaround: React.FunctionComponent<Props> = ({
  flights,
  airports,
  transId,
  inFocus,
  gcrMode,
  codeType,
  pageGroup,
  flightChanges,
  airportSeasons,
  onChange,
  onFillDown,
  touched,
  customShowLabelConfig,
  isEditSeries
}) => {
  const handleFlightChange = (
    flight: Flight,
    flightIdx: number,
    name: string,
    value: any,
    error?: boolean
  ) => {
    const updFlights = _.cloneDeep(flights)

    updFlights[flightIdx] = flight
    onChange(updFlights, error, name, value)
  }

  const cFlightIdx = flights.findIndex((f) => f.requestCode === ActionCode.C)
  const rFlightIdx = flights.findIndex((f) => f.requestCode === ActionCode.R)
  const cFlight = flights[cFlightIdx]
  const rFlight = flights[rFlightIdx]
  const [hasSelectedStartDate, setHasSelectedStartDate] = useState(false)

  return (
    <Fragment>
      <div className={"d-flex ocs-transaction-item-flight"}>
        <div className="d-flex flex-column ocs-transaction-item-code">
          <p
            className={
              "d-flex align-items-center code-mt " +
              (inFocus ? "ct-code-with-caption" : "ct-code")
            }
          >
            C
          </p>
          <p className="ct-code d-flex align-items-center code-mt">R</p>
        </div>
        <div className="d-flex ocs-mt-12 ocs-mb-6">
          <div className="d-flex align-items-center ocs-transaction-flight-icons">
            <Icon className="ocs-md-trans-icon">flight_land</Icon>
          </div>
          <div>
            <TransactionFlightTurnaroundFields
              flight={cFlight}
              isEditSeries={isEditSeries}
              transId={transId}
              flightMode={FlightMode.Arrival}
              pageGroup={pageGroup}
              gcrMode={gcrMode}
              onChange={(
                newFlight,
                name: string,
                value: any,
                error?: boolean
              ) =>
                handleFlightChange(newFlight, cFlightIdx, name, value, error)
              }
              touched={touched}
              airports={airports}
              inFocus={inFocus}
              codeType={codeType}
              airportSeasons={airportSeasons}
              fieldsWithChanges={flightChanges[cFlightIdx]}
              customShowLabelConfig={customShowLabelConfig}
            />
            <TransactionFlightTurnaroundFields
              flight={rFlight}
              isEditSeries={isEditSeries}
              transId={transId}
              flightMode={FlightMode.Arrival}
              onChange={(
                newFlight,
                name: string,
                value: any,
                error?: boolean
              ) =>
                handleFlightChange(newFlight, rFlightIdx, name, value, error)
              }
              pageGroup={pageGroup}
              airports={airports}
              gcrMode={gcrMode}
              inFocus={inFocus}
              codeType={codeType}
              airportSeasons={airportSeasons}
              fieldsWithChanges={flightChanges[rFlightIdx]}
              onFillDown={(field) => onFillDown(rFlightIdx, field)}
              touched={touched}
              customShowLabelConfig={customShowLabelConfig}
              onChangeHasSelectedStartDate={setHasSelectedStartDate}
            />
          </div>
        </div>
      </div>
      <div className={"d-flex ocs-transaction-item-flight"}>
        <div className="d-flex flex-column ocs-transaction-item-code">
          <p className="ct-code d-flex align-items-center">C</p>
          <p className="ct-code d-flex align-items-center code-mt">R</p>
        </div>
        <div className="d-flex ocs-mb-12">
          <div
            //   style={{ height: isRRow ? "30px" : "53px" }}
            className="d-flex align-items-center ocs-transaction-flight-icons"
          >
            <Icon className="ocs-md-trans-icon">flight_takeoff</Icon>
          </div>
          <div>
            <TransactionFlightTurnaroundFields
              flight={cFlight}
              transId={transId}
              isEditSeries={isEditSeries}
              flightMode={FlightMode.Departure}
              onChange={(
                newFlight,
                name: string,
                value: any,
                error?: boolean
              ) =>
                handleFlightChange(newFlight, cFlightIdx, name, value, error)
              }
              airports={airports}
              pageGroup={pageGroup}
              inFocus={inFocus}
              gcrMode={gcrMode}
              codeType={codeType}
              airportSeasons={airportSeasons}
              fieldsWithChanges={flightChanges[cFlightIdx]}
              touched={touched}
              customShowLabelConfig={customShowLabelConfig}
            />
            <TransactionFlightTurnaroundFields
              touched={touched}
              flight={rFlight}
              transId={transId}
              isEditSeries={isEditSeries}
              flightMode={FlightMode.Departure}
              onChange={(
                newFlight,
                name: string,
                value: string,
                error?: boolean
              ) =>
                handleFlightChange(newFlight, rFlightIdx, name, value, error)
              }
              gcrMode={gcrMode}
              pageGroup={pageGroup}
              airports={airports}
              inFocus={inFocus}
              codeType={codeType}
              airportSeasons={airportSeasons}
              fieldsWithChanges={flightChanges[rFlightIdx]}
              onFillDown={(field) => onFillDown(rFlightIdx, field)}
              customShowLabelConfig={customShowLabelConfig}
              hasSelectedStartDate={hasSelectedStartDate}
              onChangeHasSelectedStartDate={setHasSelectedStartDate}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default TransactionFlightTurnaround
